export default __webpack_public_path__ + "static/media/logo_nft42.376d2843.png";